import { Component, effect } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { User } from '../../core/models/user.model';
import { environment } from '../../../environments/environment';
import { releaseNotes } from '../../../../release-notes.json';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-settings-view',
    imports: [MatCardModule, MatButtonModule],
    templateUrl: './settings-view.component.html',
    styleUrl: './settings-view.component.scss',
    standalone: true
})
export class SettingsViewComponent {
    public user!: User;

    appVersion = environment.version;
    releaseNotes = releaseNotes;

    constructor(public authService: AuthService) {
        effect(async () => {
            this.user = this.authService.userDetails();
        })
    }
}